// api.js
import axios from 'axios';
import { baseUrl, baseUrl_SPB } from '../../../BaseUrl';

export const FetchCompanyById = async (token) => {
   
    const response = await fetch(`${baseUrl_SPB}/api/v1/company/fetchcompanybyid`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    console.log('fetch preference by user');
    console.log(response);
    
    const data = response?await response.json():'';

   
    return data;
};

export const SaveCompanyXeroConfiguration = async (token, company) => {
   
    try {
        await axios.post(`${baseUrl_SPB}/api/v1/company/savexeroconfiguration`,
            company ,
            {
                headers: {

                    'Authorization': 'Bearer ' + token
                }
            });

        return true;
    } catch (error) {
        console.error('Save preferences error:', error);
        return false;
    }
};
